import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';

const First:React.FC<any> =  () => {
  const navigate = useNavigate();
  const handleMoreSubscribe = () => {
    ReactPixel.fbq('track', 'StartTrial', {
      "currency": "KRW",
      "value" : 0.00,
      "predicted_ltv" : 10000,
      "event_type" : "top"
    });
    navigate('/subscribe');
    // window.location.href = "/login"
  }

  // useEffect(() => {
  //   console.log(topButtonRef.current?.offsetTop)
  // }, [])

  return (
    // <Container>
    //   <BackgroundLogo src="/images/newLanding/home/main.png"/>
    //   <BoldText>중요한 사진,<br/> 인화가 막막해 미뤘다면<br/> 인화구독으로 속시원히 해결하세요</BoldText>
    //   <SmallText>
    //     매달 에센셜한 5~20장을 골라두세요.
    //     <br/>알아서 인화해드려요. 빨리 시작하세요!
    //   </SmallText>
    //   <CircularButtonWrapper
    //     onClick={handleMoreSubscribe}
    //   >
    //     <CircularButton>
    //       인화구독 자세히 알아보기
    //     </CircularButton>
    //   </CircularButtonWrapper>
    // </Container>

    <Container>
      <BackgroundLogo src="/images/newLanding/home/main.png"/>
      <BoldText>아이의 첫 순간들로 
        <br/>바쁜 엄마도 앨범을 만들 수 있는
        <br/>단 하나의 방법
      </BoldText>
      <SmallText>
        매달 드리는 알림과 함께, 
        <br/>평생 남기고 싶은 순간을 업로드하세요.
        <br/>인화된 사진이 매 달 집 앞으로 배송됩니다.
        <br/>오늘부터 시작해보세요!
      </SmallText>
      <CircularButtonWrapper
        onClick={handleMoreSubscribe}
      >
      <CircularButton>
        자세히 알아보기
      </CircularButton>
    </CircularButtonWrapper>
  </Container>
  )
};

export default First;

const Container = styled.div`
  width: 100%;
  /* height: 100%; */
  /* min-height: 200vh; */
  display: flex;
  flex-direction: column;
`;
const BackgroundLogo = styled.img`
  width: 100%;
`;

const BoldText = styled.h1`
  font-weight: 600;
  font-size: 24px;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 55px;
  line-height: 1.5;
  letter-spacing: -0.8px;
`;

const SmallText = styled.div`
  font-size: 15px;
  margin-bottom: 15px;
  line-height: 1.5;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  text-align: center;
  letter-spacing: -0.5px;
`;

const CircularButtonWrapper = styled.div`
  display: flex;
  margin: 35px auto 70px;
  width: 70%;
  height: 55px;
`;

const CircularButton = styled.button`
  width: 100%;
  border-radius: 30px;
  /* background-color: #e1a349; */
  background-color: black;
  color: #fff;
  font-weight: bold;
`;


